<template>
  <OrganismsBaseLayout>
    <slot />
  </OrganismsBaseLayout>
</template>
